export default "__VITE_ASSET__47gVmh6W__"